import { render } from "./FTSMonthlyTable.vue?vue&type=template&id=e3633930&scoped=true&ts=true"
import script from "./FTSMonthlyTable.vue?vue&type=script&lang=ts"
export * from "./FTSMonthlyTable.vue?vue&type=script&lang=ts"

import "./FTSMonthlyTable.vue?vue&type=style&index=0&id=e3633930&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3633930"]])

export default __exports__